<app-filters-panel [formGroup]="form">
    <app-filters-group title="Id Elaborazione" [form]="form" [filtersGroup]="['idElaborazione_equals']">
        <app-input-text name="idElaborazione_equals" label="Id elaborazione" [form]="form"></app-input-text>
    </app-filters-group>

    <app-elaborazione-select [title]="'Tipo file elaborazione'" [form]="form" name="type_equals" [label]="'Tipo file elaborazione'"
    [optionsValue]="['EXCEL', 'JSON']"></app-elaborazione-select>
    <app-elaborazione-select [title]="'Contenuto elaborazione'" [form]="form" name="content_equals" [label]="'Contenuto elaborazione'" 
    [optionsValue]="['PIANI_CONTROLLO', 'CONTROLLI', 'REPORTNET3', 'STORICO']"></app-elaborazione-select>
    <app-elaborazione-select [title]="'Stato elaborazione'" [form]="form" name="statoElaborazione_equals" [label]="'Stato elaborazione'" 
    [optionsValue]="['ELABORAZIONE_INSERITA_IN_CODA', 'ELABORAZIONE_INIZIATA', 'SALVATO_SU_DATALAKE', 'ANALISI_DEL_FILE_IN_CORSO', 'DATI_INSERITI_NEL_DATABASE', 
        'ELABORAZIONE_CONCLUSA', 'ELIMINAZIONE_IN_CORSO', 'ELABORAZIONE_ELIMINATA', 'ERRORE']"></app-elaborazione-select>

     <app-filters-group title="Data e ora Elaborazione" [form]="form" [filtersGroup]="['createdAt_equals']">
        <app-input-date name="createdAt_equals" label="Data e ora elaborazione" [form]="form"></app-input-date>
    </app-filters-group>
</app-filters-panel>